import { h } from 'preact';
import { useCartContext } from '../context/CartContext';

const CartEmpty = () => {
  const { miniCartData } = useCartContext();
  const {
    emptyCartTitle,
    emptyCartSubheading,
    cartUpsellButtonText,
    cartUpsellButtonUrl,
    cartUpsellCollections,
    underButtonText,
  } = miniCartData.settings;

  const hasUpsellButton = !!cartUpsellButtonText && !!cartUpsellButtonUrl;
  const hasUpsellCollections = cartUpsellCollections?.length > 0;

  return (
    <div class="flex flex-col px-4 py-8 text-center">
      <p class="type-heading-4">{emptyCartTitle}</p>
      {emptyCartSubheading && (
        <p class="type-body-small mt-2 text-secondary-2">
          {emptyCartSubheading}
        </p>
      )}
      {hasUpsellCollections && (
        <div class="mt-8 grid grid-cols-2 gap-4">
          {cartUpsellCollections.map(collection => (
            <a
              href={collection.url}
              key={collection.id}
              class="group flex flex-col items-center"
            >
              {!!collection?.image && (
                <div class="aspect-square w-full overflow-hidden rounded-lg">
                  <img
                    src={collection.image}
                    class="h-full w-full object-cover lg:transition-transform lg:group-hover:scale-105"
                  />
                </div>
              )}
              <h5 class="type-heading-6 mt-2">{collection.title}</h5>
              <h6 class="type-body-xsmall mt-1 uppercase text-secondary-2">
                {collection.count} products
              </h6>
            </a>
          ))}
        </div>
      )}
      {hasUpsellButton && (
        <a
          href={cartUpsellButtonUrl}
          class="button button--primary button--block mt-4"
        >
          {cartUpsellButtonText}
        </a>
      )}
      {underButtonText && <p class="type-body-small mt-4">{underButtonText}</p>}
    </div>
  );
};

export default CartEmpty;
